import { useMutation } from "@apollo/client"
import gql from "graphql-tag"
import fragments from "modules/contribution/graphqlFragments"
import { CurrentFlow } from "modules/contribution/types"

const CREATE_FULL_CONTRIBUTION_DRAFT = gql`
mutation CreateFullContributionDraft($input: CreateFullContributionDraftInputType!) {
  createFullContributionDraft(input: $input) {
    ...ContributionDraftFragment
  }
}
${fragments.contributionDraft}
`

export const useCreateFullContributionDraftMutation = ({
  onSuccess,
  onError
}: {
  onSuccess: (draft: {
    amount: number
    currentFlow: CurrentFlow
    fund: { uuid: string}
    user: { uuid: string}
  }) => void
  onError: (err: any) => void
}) => {
  const [createFullContributionDraftMutation, { data, loading, error }] = useMutation(CREATE_FULL_CONTRIBUTION_DRAFT)

  const createFullContributionDraft = async (input: any) => {
    await createFullContributionDraftMutation({
      variables: {
        input,
      },
    }).then(async ({ data: { createFullContributionDraft: draft } }) => {
      onSuccess(draft)
      return draft
    }).catch((err: any) => {
      console.error(err)
      onError(err)
    })
  }

  return {
    createFullContributionDraft,
    data,
    loading,
    error
  }
}